import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { Anniversary52ndComponent } from './anniversary-52nd.component';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule
  ],
  declarations: [
    Anniversary52ndComponent,
  ],
  providers: [
  ]
})
export class Anniversary52ndModule { }



// WEBPACK FOOTER //
// ./src/app/anniversary-52nd/anniversary-52nd.module.ts